import { Button, Modal } from "antd";
import "./style.scss";
import { useInfoUser } from "../../store/UserStore";

const GeneralModal = ({
                          title,
                          content,
                          onCancel,
                          open,
                          onUpdateSchedule,
                          onConfirm,
                          onDiscard,
                          updateScheduleText,
                          confirmText,
                          discardText,
                          cancelText,
}) => {
    const { languageMap } = useInfoUser();

    const hasDiscard = typeof onDiscard === "function";
    const hasUpdateSchedule = typeof onUpdateSchedule === "function";

    return (
        <Modal
            width={450}
            open={open}
            onCancel={onCancel}
            footer={null}
            centered
            className="custom-confirm-modal"
        >
            <div className="modal-header">
                <div className="modal-title">{title ?? "Xác nhận"}</div>
                <div className="modal-divider" />
            </div>

            <div className="text-base mb-6">{content}</div>

            <div className="flex justify-end gap-2">
                <Button
                    className="!bg-[#ffffff] !text-black hover:!bg-[#d9d9d9] font-medium"
                    onClick={onCancel}
                >
                    {cancelText ?? languageMap?.["modal.cancel"] ?? "Cancel"}
                </Button>
                {hasDiscard && (
                    <Button
                        className="!bg-[#faad14] !text-white hover:!bg-[#ffc53d] font-medium"
                        onClick={onDiscard}
                    >
                        {discardText ?? "Discard"}
                    </Button>
                )}
                <Button
                    className="!bg-[#ff4d4f] !text-white hover:!bg-[#ff7875] font-medium"
                    onClick={() => {
                        onConfirm?.();
                        onCancel?.();
                    }}
                >
                    {confirmText ?? languageMap?.["modal.ok"] ?? "OK"}
                </Button>
              {hasUpdateSchedule &&
                <Button
                  className="!bg-[#2a56b9] !text-white hover:!bg-[#2a56b9] font-medium"
                  onClick={onUpdateSchedule}
              >
                {updateScheduleText}
              </Button>
              }
            </div>
        </Modal>
    );
};

export { GeneralModal };